<template>
  <crud
    mode="ServerSide"
    deleteMode="hard"
    :update-many-mode="false"
    :resolverType="resolverType"
    :list="list"
    :get="get"
    :create="create"
    :update="update"
    :remove="remove"
    :page-title="pageTitle"
    :fields-info="fieldsInfo"
    :details-title="$t('detailsTitle')"
    :custom-buttons="buttons"
    :item-elements="itemElements"
    ref="crud"
  >
  </crud>
</template>

<script>

import Crud from '@/utils/crud/components/Crud.vue'
import {
  mapActions,
} from 'vuex'

export default {
  data () {
    return {
      resolverType: 'dynamodb',
      list: 'listUsers',
      get: 'getUser',
      create: 'createUser',
      update: 'updateUser',
      remove: 'deleteUser',
      pageTitle: 'admin.users'
    }
  },
  computed: {
    itemElements () {
      return {
        // userPermissions: {
        //   title: this.$t('itemElements.userPermissions.title'),
        //   url: 'admin/users/{id}/permissions',
        //   query: 'listUserPermissions',
        //   controller: 'crud/admin/user-permissions',
        //   itemObject: 'permission_users',
        //   columns: [
        //     {
        //       obj: 'name',
        //       name: 'permission',
        //       header: this.$t('itemElements.userPermissions.headers.permission'),
        //     },
        //   ],
        //   primaryId: 'user_id',
        //   foreignId: 'permission_id',
        //   icon: 'lock_open',
        //   color: 'purple',
        //   buttonText: this.$t('itemElements.userPermissions.title'),
        // },
        // groups: {
        //   title: this.$t('itemElements.groups.title'),
        //   // url: 'crm/positions/{id}/tasks',
        //   controller: 'users/groups',
        //   itemObject: 'groups',
        //   icon: 'lock_open',
        //   color: 'purple',
        //   buttonText: this.$t('itemElements.userPermissions.title'),
        //   columns: [
        //     {
        //       obj: 'name',
        //       name: 'groups',
        //       header: this.$t('itemElements.group.headers.name'),
        //     },
        //   ],
        // }
      }
    },
    buttons () {
      return [
    //     {
    //       name: 'resetPassword',
    //       icon: 'autorenew',
    //       color: 'blue',
    //       text: this.$t('buttons.resetPassword'),
    //     },
      ]
    },
    fieldsInfo () {
      return [
        {
          text: this.$t('fields.id'),
          name: 'id',
          details: false,
          table: false
        },
        {
          type: 'input',
          column: 'user',
          text: this.$t('fields.user'),
          name: 'user',
          multiedit: false,
          create: true
        },
        {
          type: 'input',
          column: 'email',
          text: this.$t('fields.email'),
          name: 'email',
          multiedit: false,
          create: true
        },
        {
          type: 'list',
          column: 'groups',
          text: this.$t('fields.groups'),
          name: 'groups',
          // table: false,
          // stringId: true,
          create: true,
          edit: true,
          chips: true,
          multiple: true,
          list: {
            data: [
              'TODO',
              'OPTICHECK',
              'ADWORDS',
              'ADMIN'
            ]
          }
        },
        // {
        //   type: 'select',
        //   query: 'listPermissions',
        //   list: {
        //     value: 'id',
        //     text: 'groups',
        //     data: [],
        //   },
        //   // column: 'user_id',
        //   column: 'userPermissionUserId',
        //   text: this.$t('fields.groups'),
        //   name: 'groups',
        //   apiObject: {
        //     name: 'groups.name',
        //   },
        // },
        // {
        //   type: 'select',
        //   column: 'groups',
        //   text: this.$t('fields.groups'),
        //   list: {
        //     value: 'id',
        //     text: 'groups',
        //     data: [],
        //   },
        // }
        // {
        //   type: 'select',
        //   url: 'crud/admin/user-types',
        //   list: {
        //     value: 'id',
        //     text: 'name',
        //     data: [],
        //   },
        //   column: 'user_type_id',
        //   text: this.$t('fields.userType'),
        //   name: 'user_type',
        //   apiObject: {
        //     name: 'user_type.name',
        //   },
        // },
        // {
        //   text: this.$t('fields.initialPassword'),
        //   name: 'initialPassword',
        //   apiObject: {
        //     name: 'initial_password',
        //   },
        //   details: false,
        // },
      ]
    },
  },
  methods: {
    resetPassword (item) {
    },
    //   Vue.http.put('admin/users/' + item.id + '/reset-password')
    //     .then((response) => {
    //       this.openAlertBox([
    //         'alertSuccess',
    //         this.$t('passwordReseted'),
    //       ])
    //       this.getItems()
    //     })
    // },
  },
  components: {
    Crud,
  },
  i18n: {
    messages: {
      de: {
        detailsTitle: 'Benutzer',
        fields: {
          id: 'Id',
          user: 'Benutzername',
          email: 'E-Mail',
          groups: 'Gruppen',
          initialPassword: 'Initiales Passwort',
          userType: 'User Typ',
        },
        itemElements: {
          userPermissions: {
            title: 'Benutzerrechte',
            headers: {
              permission: 'Rechte',
            },
          },
        },
        buttons: {
          resetPassword: 'Passwort zurücksetzen',
        },
        passwordReseted: 'Passwort zurückgesetzt',
        passwordResetError: 'Fehler: Passwort konnte nicht zurückgesetzt werden',
      },
      en: {
        detailsTitle: 'User',
        fields: {
          id: 'Id',
          user: 'Username',
          email: 'E-mail',
          groups: 'Groups',
          initialPassword: 'Initial password',
          userType: 'User type',
        },
        itemElements: {
          userPermissions: {
            title: 'User permissions',
            headers: {
              permission: 'Permission',
            },
          },
        },
        buttons: {
          resetPassword: 'Reset password',
        },
        passwordReseted: 'Password changed',
        passwordResetError: 'Error! Password change unsuccessful',
      },
    },
  },
}

</script>
